export default __webpack_public_path__ + "static/media/cgu-cgv.c45d12c3.pdf";